var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('organism-use-config-template',{attrs:{"id":_vm.id,"templateDetail":_vm.templateDetail,"generateConfig":_vm.generateConfig},on:{"clickGenerate":_vm.clickGenerateToApi}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }